import {MultiSelectChipInput, MultiSelectChipInputProps} from "~/apps/core/ui/ChipInput/MultiSelectChipInput";
import React, {useMemo} from "react";
import {FiberManualRecord} from "@mui/icons-material";
import {Grid} from "@mui/material";
import {Admission} from "~/queries";
import {getAdmissionStatusColor, humanizeAdmissionStatus} from "~/apps/packages/passes/utils";


export type AdmissionStatesChipInputProps = Omit<MultiSelectChipInputProps<Admission["status"]>, "options" | "title">;
const ADMISSION_STATUS_LIST: Admission["status"][] = [
    1,
    2,
    3,
    4,
    5,
    -1,
    -3,
    -4,
]


export const AdmissionStatesChipInput = (props: AdmissionStatesChipInputProps) => {
    const {value: oValue, onChange, ...other} = props;

    const titleValuesMap = useMemo(() => {
        const groups = new Map<string, Set<Admission["status"]>>();
        for (const state of ADMISSION_STATUS_LIST) {
            const title = humanizeAdmissionStatus(state);
            if (!groups.has(title)) {
                groups.set(title, new Set());
            }
            groups.get(title).add(state);
        }
        return groups;
    }, []);

    const iValue = useMemo(() => {
        const iValue = [];
        const oValueAsSet = new Set(oValue || []);
        for (const [title, values] of titleValuesMap.entries()) {
            const noMatch = [...values].find(v => !oValueAsSet.has(v))
            if (!noMatch){
                iValue.push(title);
            }
        }
        return iValue;
    }, [oValue, titleValuesMap]);

    const options = useMemo(() => {
        const options = [];
        for (const [title, value] of titleValuesMap.entries()) {
            options.push({
                value: title,
                title: (
                    <Grid container alignItems="center">
                        <FiberManualRecord style={{color: getAdmissionStatusColor(value.values().next().value), width: 8, marginRight: 8}}/>
                        {title}
                    </Grid>
                )
            });
        }
        return options;
    }, [titleValuesMap]);


    const handleChange = (value) => {
        value = value || [];
        const outValue = [];
        for (const title of value) {
            outValue.push(...titleValuesMap.get(title));
        }
        onChange && onChange(outValue);
    }


    return (
        <MultiSelectChipInput
            {...other}
            title="Статус"
            options={options}
            value={iValue}
            onChange={handleChange}
        />
    )
}